<template>
  <div class="modal-window uts005">
    <header class="modal-header">
      <div class="tit">{{ $i18nUtil.trans("title.Noti.001","알림") }}</div>
      <button @click="$emit('close')" class="btn_close">{{$i18nUtil.trans("button.close","닫기")}}</button>
    </header>

    <div class="modal-content">
      <div class="txt2">{{ $i18nUtil.trans("message.Noti.001","일자별로 알림 정보를 확인할 수 있습니다.") }}</div>
      <div class="calendar_box_grp">
        <div class="calendar_box" >
          <datepicker
            format="yyyy.MM.dd"
            :disabled-dates="startDisabledDate"
            :value="startDate"
            @selected="selectedStartDate"
          ></datepicker> <!-- @opened 이벤트가 방출됨. @focusin.native="datepickerOpenedFunction"  -->
        </div>
        <span>~</span>
        <div class="calendar_box">
          <datepicker
            format="yyyy.MM.dd"
            :disabled-dates="endDisabledDate"
            :value="endDate"
            @selected="selectedEndDate"
          ></datepicker>
        </div>
      </div>
      <div class="clear">
        <div class="fr"> 
          <button
            type="button"
            class="btn-primary-smaller"
            @click="deleteNotiRead()"
          >
            {{ $i18nUtil.trans("button.readed.notice.delete","읽은 알림 삭제") }}
          </button>
          <button
            type="button"
            class="btn-primary-smaller"
            @click="deleteNotiAll()"
          >
            {{ $i18nUtil.trans("button.all.delete","전체 삭제") }}
          </button>
          <button type="button" class="btn-refresh" @click="setNotiMessage()">
            {{$i18nUtil.trans("button.refresh","새로고침")}}
          </button>
        </div>
      </div>
      <div class="scroll">
        <div class="inner" id="innerScroll">
          <div class="history clear">
            <div class="nodata" v-show="dateArray.length == 0">
              {{ $i18nUtil.trans("message.Noti.002","알림 내역이 없습니다.") }}
            </div>
            <div class="date_wrap">
              <div class="task_box_day" v-for="(date, idx) in dateArray" :key="'notiArr_' + idx" :class="idx == currentIndex ? '' :'active'">
                <div class="day" @click="changeDate(date, idx)" :id='date.date' name='day'
                  v-if=" $moment(date.date).format('YYYY-MM-DD') == $moment().format('YYYY-MM-DD') " >
                  {{$i18nUtil.trans("message.today","오늘")}}
                </div>
                <!-- <div class="day" v-if="$moment(noti[0].notiInfo.sendDate).format('YYYY-MM-DD') == $moment().subtract(1, 'day').format('YYYY-MM-DD')" >  
                                    어제
                              </div> -->
                <div class="day" @click="changeDate(date, idx)" :id='date.date' name='day'
                     v-if=" $moment(date.date).format('YYYY-MM-DD') <= $moment().subtract(1, 'day').format('YYYY-MM-DD') " >
                  <!-- <momentAgo prefix="" suffix="전" :date="noti[0].sendDate" lang="kr" ></momentAgo>  -->
                  {{ $moment(date.date).format("YYYY-MM-DD") }}
                </div>
                <div class="task_box_case" v-for="(item, notiIdx) in notiList" :key="notiIdx+'noti'+idx" v-show="currentIndex == idx" >
                  <div class="left"></div>
                  <div class="right">
                    <div class="task">
                      <span>{{ $moment(item.regDate).format("LT") }}</span>
                      <span v-if="item.notiKbn != null && item.notiKbn != '보드' 
                                  && item.notiOption !='07'
                                  && item.notiOption !='06'">
                         {{ item.notiKbn == "과제" ? $i18nUtil.trans("entity.project","과제") : 
                                                    item.notiKbn == "정보공유" ? $i18nUtil.trans("entity.cogroup.groupKbn.shar","HO!") : item.notiKbn }}
                      </span>
                      <span class="ell-singleline" 
                            v-if="item.attr3 != null && item.notiOption !='07' && item.notiOption !='06' 
                                  && item.notiOption !='02' && item.notiOption !='03'">
                        {{ item.notiKbn =='프라이빗' ?  item.sendUserName : item.attr3 }}
                      </span>
                      <!-- 파일첨부 최종결과물 파일첨부시 -->
                      <span class="ell-singleline" 
                            v-if="item.attr3 != null && (item.notiOption =='02' || item.notiOption =='03') && item.notiKbn !='프라이빗'">
                        {{ item.attr3 }}
                      </span>
                      <span class="borard_name ell-singleline" 
                            v-if="item.attr4 != null && item.notiOption !='07' && item.notiOption !='06'" >
                        {{ item.attr4 }}
                      </span>
                    </div>
                    <div class="btm">
                      <div class="comment" @click="readNoti(item)" style="cursor: pointer;" v-html="setTitleMessage(item)"
                      ></div>
                      <span :class="item.readYn == 1 ? '' : 'ico-new'"></span>
                    </div>
                  </div> 
                </div>
                <div class="btn_box txtc">
                  <button type="button" class="btn-more-ico_small1 down" @click="moreData(date)"
                          v-if="notiList.length != 0 && currentIndex == idx && page+1 < totalPage">
                          {{ $i18nUtil.trans('button.data.more','{cnt}건 더보기', {cnt: totalElements-notiList.length > 10 ? '10': totalElements-notiList.length}) }}
                  </button>
                </div>
              </div> 
            </div>
            <!--//date_wrap-->
          </div>
          <!-- //history -->
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import axios from "axios";
import Datepicker from "vuejs-datepicker";
import { mapState, mapActions, mapMutations, mapGetters } from "vuex";
export default {
  props: [],
  components: {
    Datepicker
  },
  data() {
    return {
      toastInfo: {
        obj: this.$toasted,
        message: "",
        options: {
          theme: "toasted-primary",
          position: "bottom-left",
          duration: 3000
        }
      },

      startDate: new Date(
        this.$moment()
          .subtract(1, "months")
          .format("YYYY-MM-DD")
      ),
      endDate: new Date(this.$moment()),
      startDisabledDate: {
        from: new Date(this.$moment())
      },
      endDisabledDate: {
        to: new Date(
          this.$moment()
            .subtract(1, "months")
            .format("YYYY-MM-DD")
        ),
        from: new Date(this.$moment())
      },
      dateArray: [], 
      notiList: [],

      currentIndex:0, 
      totalPage:0,
      totalElements:0,
      page : 0, 

      todoTabIndex:0,
      tenantId : localStorage.getItem("tenantId"),
    };
  },
  mounted() {
    this.setNotiMessage();
  },
  beforeDestroy() {},
  computed: {
    //...mapGetters("noti",["getNotiList"]),
  },
  watch: {},
  methods: {
    ...mapActions("restAction", ["COWORK_REST_SIMPLE_ACTION"]),
    ...mapActions("modals", ["showToast"]),
    ...mapActions("noti", ["setNoneNotiReadYn","setNotiBoardBlockId","setNotiBoardCommentId"]),
    ...mapActions("noti", ["setShowNotiListPopup"]),
    showTodo(noti) {
      let popupUrl = "";
      if(noti.notiOption == '07'){
        // 할 일알림
        // MESSAGE_TODO_COMPLETE
        if(noti.notiMessage == "MESSAGE_TODO_COMPLETE"){
          this.todoTabIndex = 1;
        }else{
          this.todoTabIndex = 0;
        }

        let obj = this;
        let reqData = {};
        reqData.params = {
          todoId: noti.attr5
        };
        reqData.req = obj.req;
        reqData.url = "/api/copaper/todo/getTodo";
        reqData.method = "post";

        obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(res => { 
          if (res.errorCode != null) { 
          } else {
            popupUrl = "/general/todoNewPage?index="+this.todoTabIndex +"&startDate="+res.result.todoMain.todoStartDate;

            let hanwha = $(location).attr("origin"); 
            window.open(
              hanwha + popupUrl,
              "_blank",
              "width=1264, height=800"
            );
          }
        }).catch(function(err) { console.log(err); });
        
        // if(noti.notiMessage.indexOf("완료") != -1){
        //   this.todoTabIndex = 1;
        // }else{
        //   this.todoTabIndex = 0;
        // }
        // popupUrl = "/general/todoNewPage?index="+this.todoTabIndex+"&startDate="+noti.regDate;
      }else{
        //의사결정 알림
        // MESSAGE_DECISION_REQ
        if(noti.notiMessage == "MESSAGE_DECISION_REQ"){
          this.todoTabIndex = 1;
        }else{
          this.todoTabIndex = 0;
        }

        // if(noti.notiMessage.indexOf("새로운 의사결정 요청을 받았습니다.") != -1){
        //   this.todoTabIndex = 1;
        // }else{
        //   this.todoTabIndex = 0;
        // }
        popupUrl = "/general/perDeci?index="+this.todoTabIndex;
      
        let hanwha = $(location).attr("origin"); 
        window.open(
          hanwha + popupUrl,
          "_blank",
          "width=1264, height=800"
        );
      }
      


      this.$emit('close');
    },
    moveMessage(noti) {
      if(noti.notiOption == '07' || noti.notiOption == '06'){
        // 할 일알림 이동. 
        this.showTodo(noti); 
      }else{
        if (
          noti.notiLink == null ||
          noti.notiLink == "" ||
          noti.notiLink == undefined
        ) {
          // alert(" 잘못된 링크 입니다. ");
        } else {
          //알림 팝업을 통해 이동후 뒤로가기시 알림팝업 노출을 위함.
          let obj = this;
         
          let reqData = {
            url : "/api/org/getCodeValueList",
            method : "post",
            params : {
              tenantId : "DEFAULT",
              cdCategory: 'tenant.env',
              cdKey: 'back.alarm.popup.yn'
            }
          };
          obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then(res => {
            let codeList = res.result;
            let mobileLoginUseTenantIds = codeList[0].cdValue;
            let checkTenantIdArr = mobileLoginUseTenantIds.split(',');

            if(noti.notiLink.indexOf("/board") != -1){
              //보드 링크 
              let obj = this;
              let reqData = {};
              reqData.params = {
                paperId: noti.attr2
              };
              reqData.req = obj.req;
              reqData.url = "/api/copaper/paper/getPaperInfo";
              reqData.method = "post";
        
              obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(res => { 
                  if (res.errorCode != null) { 
                  } else {    
                    if(res.result.deleteYn == 0){ 
                      this.setNotiBoardCommentId(null);
                      this.setNotiBoardBlockId(null);
                      if(noti.notiMessage == "MESSAGE_FILE_REGIST"){
                        if(noti.attr6 != null){ 
                          this.setNotiBoardBlockId(noti.attr6); 
                        }
                      }else if (noti.notiMessage == "MESSAGE_BOARD_OPINION_REGIST" || 
                                noti.notiMessage == "MESSAGE_BOARD_OPINION_REPLY"){
                        if(noti.attr5 != null){ 
                          this.setNotiBoardBlockId(noti.attr5); 
                        }
                        if(noti.attr6 != null){
                          this.setNotiBoardCommentId(noti.attr6);
                        }
                      }  
                      
                      if(checkTenantIdArr.indexOf(this.tenantId) > -1 ){
                        this.setShowNotiListPopup(true);
                      }

                      this.$router.push(noti.notiLink);
                    }else{
                      obj.toastInfo.message = obj.$i18nUtil.trans('TB045');
                      obj.showToast(obj.toastInfo);
                    }
                  }
                }).catch(function(err) { console.log(err); });
            }else if(noti.notiLink.indexOf("/dashboard") != -1){
              // 과제로 이동
              // 링크  getProjectInfo 
              let obj = this;
              let reqData = {};
              reqData.params = {
                projectId : noti.attr1
              };
              reqData.req = obj.req;
              reqData.url = "/api/cogroup/project/getProjectInfo";
              reqData.method = "post";
        
              obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(res => { 
                  if (res.errorCode != null) { 
                  } else {  
                    if(res.result.project.delDate == null){
                      if(checkTenantIdArr.indexOf(this.tenantId) > -1){
                        this.setShowNotiListPopup(true);
                      }

                      // 과제 의견 관련 이동 
                      // MESSAGE_PROJECT_OPINION_REGIST MESSAGE_PROJECT_OPINION_REPLY
                      if( noti.notiMessage == "MESSAGE_PROJECT_OPINION_REGIST" || 
                          noti.notiMessage == "MESSAGE_PROJECT_OPINION_REPLY" ){
                        this.$router.push(noti.notiLink+"?commentYn=1");
                      }else{
                        this.$router.push(noti.notiLink);
                      }

                      // if(noti.notiMessage.indexOf("의견") != -1 || noti.notiMessage.indexOf("답변") != -1){
                      //   this.$router.push(noti.notiLink+"?commentYn=1");
                      // }else{
                      //   this.$router.push(noti.notiLink);
                      // }
                    }else{
                      obj.toastInfo.message = obj.$i18nUtil.trans("TB045.002");
                      obj.showToast(obj.toastInfo);
                    }
                  }
                }).catch(function(err) { console.log(err); });
            }else{
              //카테고리 링크 (회의협의, 정보공유, 프라이빗.);
              let obj = this;
              let reqData = {};
              reqData.params = {
                categoryMid : noti.attr1
              };
              reqData.req = obj.req;
              reqData.url = "/api/copaper/category/getCategoryInfo";
              reqData.method = "post";
        
              obj
                .COWORK_REST_SIMPLE_ACTION(reqData)
                .then(res => { 
                  if (res.errorCode != null) { 
                  } else {   
                    if(res.result.delKbn == 0){
                      if(checkTenantIdArr.indexOf(this.tenantId) > -1){
                        this.setShowNotiListPopup(true);
                      }
                      this.$router.push(noti.notiLink);
                    }else{
                      obj.toastInfo.message = obj.$i18nUtil.trans("TB045.001");
                      obj.showToast(obj.toastInfo);
                    }
                  }
                }).catch(function(err) { console.log(err); });
            } 
          })
          .catch(function(err) {
            console.log(err);
          }); 
        }
      }
    },
    setNotiMessage() {
      this.currentIndex =0;
      this.notiList = []; 
      this.dateArray = [];
      if (this.endDate == null) {
        this.endDate = new Date(this.$moment());
      }

      let obj = this;
      let reqData = {};
      reqData.params = {
        startDate: this.$moment(this.startDate).format("YYYY-MM-DD"),
        endDate: this.$moment(this.endDate).format("YYYY-MM-DD")
      };
      reqData.req = obj.req;
      reqData.url = "/api/noti/getNotiDateList";
      reqData.method = "post";
 
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(res => { 
          if (res.errorCode != null) {
            console.log(res.errorMessage);
          } else {  
            this.dateArray = [];
            this.dateArray = res.result.notiDateList;  
            if(this.dateArray.length != 0){
              this.getNotiListByPaging(this.dateArray[0].date); 
            }
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    getNotiListByPaging(date){
      let obj = this;
      let reqData = {};
      reqData.params = { 
        selectedDate : date,
        page : obj.page
      };
      reqData.req = obj.req;
      reqData.url = "/api/noti/getNotiListByCalendarPaging";
      reqData.method = "post"; 
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(res => { 
          if (res.errorCode != null) {
            console.log(res.errorMessage);
          } else {   
            obj.totalPage = res.result.notiList.totalPages;
            obj.totalElements = res.result.notiList.totalElements;
            let newList = res.result.notiList.content;
            for(let k in newList){
              obj.notiList.splice(obj.notiList.length, 0, newList[k]);
            }  
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    changeDate(date, idx){   
      if(idx == this.currentIndex) {
        if(!event.target.parentElement.classList.contains("active")) {
          event.target.parentElement.classList.add("active"); 
          this.notiList = []; 
          return;
        } else {
          event.target.parentElement.classList.remove("active");
        }
      } 
      this.currentIndex = idx; 
      this.notiList = [];  
      this.page =0;
      this.getNotiListByPaging(date.date);   
  
      const inner = document.getElementById("innerScroll");  
      
      //.scroll({ top: 2500, left: 0, behavior: 'smooth' });
      if(idx == 0 ){
        //inner.scrollTo(0,0);
        // inner.scroll({top: 0, behavior: 'smooth'});
        inner.scrollTop = 0;
      }else{
        //inner.scrollTo(0,(88*idx)+45);
        // inner.scroll({top: (88*idx)+45, behavior: 'smooth'});
        inner.scrollTop = (88*idx)+45;
      }
    },
    moreData(date){
      this.page ++;
      this.getNotiListByPaging(date.date);
    },
    deleteNotiAll() {
      if(this.dateArray.length == 0){
        return;
      }
      let obj = this;
      let reqData = {};
      reqData.params = {};
      reqData.req = obj.req;
      reqData.url = "/api/noti/deleteNotiAll";
      reqData.method = "post"; 
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(res => { 
          if (res.errorCode != null) {
            console.log(res.errorMessage);
          } else {
            this.setNotiMessage();
            obj.toastInfo.message = obj.$i18nUtil.trans("message.Noti.005","전체 알림이 삭제되었습니다.");
            obj.showToast(obj.toastInfo);
            obj.setNoneNotiReadYn(); //읽지 않은 알림 값 조회/저장
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    deleteNotiRead() {
      if(this.dateArray.length == 0){
        return;
      }
      let obj = this;
      let reqData = {};
      reqData.params = {};
      reqData.req = obj.req;
      reqData.url = "/api/noti/deleteNotiRead";
      reqData.method = "post"; 
      obj
        .COWORK_REST_SIMPLE_ACTION(reqData)
        .then(res => { 
          if (res.errorCode != null) {
            console.log(res.errorMessage);
          } else {
            if(res.result != null){
              this.setNotiMessage(); 
              obj.toastInfo.message = obj.$i18nUtil.trans("message.Noti.006","읽은 알림이 삭제되었습니다.");
              obj.showToast(obj.toastInfo);
            }
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    readNoti(item) {
       
      if (item.readYn == 0) {
        let obj = this;
        let reqData = {};
        reqData.params = {
          notiTargetId: item.notiTargetId
        };
        reqData.req = obj.req;
        reqData.url = "/api/noti/readNoti";
        reqData.method = "post";
        obj
          .COWORK_REST_SIMPLE_ACTION(reqData)
          .then(res => {
            if (res.errorCode != null) {
              console.log(res.errorMessage);
            } else {
              for (let k in this.notiList) {
                if (this.notiList[k].notiTargetId == item.notiTargetId) {
                  this.notiList[k].readYn = 1;
                }
              }
              //router
              this.moveMessage(item);
              //this.$router.push(item.notiLink);
            }
          })
          .catch(function(err) {
            console.log(err);
          });
      } else {
        //router
        this.moveMessage(item);
      }
    },
    selectedStartDate(date) {
      // let test1 = document.getElementsByClassName('calendar_box')[0].focusout(); 

      // let test = test1.getElementsByTagName('input').focusout(); 
      document.body.focus();
      this.endDisabledDate.to = new Date(this.$moment(date));
      this.startDate = new Date(this.$moment(date));
      if (
        this.$moment(date).format("YYYY-MM-DD") >
        this.$moment(this.endDate).format("YYYY-MM-DD")
      ) {
        this.endDate = new Date(this.$moment(date));
      }
      this.setNotiMessage();
    },
    selectedEndDate(date) {
      document.body.focus();
      this.endDate = new Date(this.$moment(date));
      this.setNotiMessage();
    },
    setTitleMessage(item) {

      let defaultLanguage = localStorage.getItem("defaultLanguage") || 'ko';

      let sendUserName = defaultLanguage.indexOf("ko") != -1 ? item.sendUserName : item.sendUserNameEn != null ? item.sendUserNameEn : item.sendUserName;

      //21.06.28 코드값으로 변경
      if(
          item.notiMessage == "MESSAGE_FILE_REGIST" ||
          item.notiMessage == "MESSAGE_OUTPUTS_REGIST" ||
          item.notiMessage == "MESSAGE_FILE_OPINION_REGIST" ||
          item.notiMessage == "MESSAGE_BOARD_OPINION_REPLY" ||
          item.notiMessage == "MESSAGE_FILE_OPINION_REPLY" ||
          item.notiMessage == "MESSAGE_PROJECT_OPINION_REPLY" ||
          item.notiMessage == "MESSAGE_DECISION_REQ" ||
          item.notiMessage == "MESSAGE_DECISION_APPR" ||
          item.notiMessage == "MESSAGE_DECISION_REJECT" ||
          item.notiMessage == "MESSAGE_MEMBER_INVITATION" 
        ){
          return this.$i18nUtil.trans(item.notiMessage,{sendUser:sendUserName});
      } else if(
        item.notiMessage == "MESSAGE_PBOARD_REGIST" 
      ){
         let sharCheck = item.notiKbn === "정보공유" ? "MESSAGE_PBOARD_REGIST_SHAR":item.notiMessage;
         return this.$i18nUtil.trans(sharCheck,{sendUser:sendUserName});
      } else if(
        item.notiMessage == "MESSAGE_BOARD_OPINION_REGIST"
      ){
         let sharCheck = item.notiKbn === "정보공유" ? "MESSAGE_BOARD_OPINION_REGIST_SHAR":item.notiMessage;
         return this.$i18nUtil.trans(sharCheck,{sendUser:sendUserName});
      } else if(
        item.notiMessage == "MESSAGE_BOARD_MEMBER_REGIST"
      ){
         let sharCheck = item.notiKbn === "정보공유" ? "MESSAGE_BOARD_MEMBER_REGIST_SHAR":item.notiMessage;
         return this.$i18nUtil.trans(sharCheck,{sendUser:sendUserName});
      } else if(
        item.notiMessage == "MESSAGE_SPACE_MEMBER_REGIST" ||
        item.notiMessage == "MESSAGE_PROJECT_OPINION_REGIST" ||
        item.notiMessage == "MESSAGE_MEMBER_REGIST_OTHER" ||
        item.notiMessage == "MESSAGE_MEMBER_APPLY" 
      ){
        if(item.notiKbn == "과제"){
          return this.$i18nUtil.trans(item.notiMessage,{sendUser:sendUserName,location:this.$i18nUtil.trans("entity.project","과제")});
        }else{
          let sharCheck = item.notiKbn === "정보공유" ? this.$i18nUtil.trans("entity.cogroup.groupKbn.shar","정보공유"): item.notiKbn;
          return this.$i18nUtil.trans(item.notiMessage,{sendUser:sendUserName,location:sharCheck});
        }
      }else if(
        item.notiMessage == "MESSAGE_TODO_REQ" ||
        item.notiMessage == "MESSAGE_TODO_COMPLETE" ||
        item.notiMessage == "MESSAGE_TODO_DELETE" 
      ){
        return this.$i18nUtil.trans(item.notiMessage,{task:this.$i18nUtil.trans("MESSAGE_TASK"),sendUser:sendUserName});
      }else{
        return this.$i18nUtil.trans(item.notiMessage,{sendUser:sendUserName});
      }

      // 04.27 :  tenantId=418502 일때 처리 
      // let tenantId = localStorage.getItem("tenantId");
 
      // if( item.notiType == "TYPE_MEMBER_REGIST" ||
      //     item.notiType == "TYPE_BOARD_MEMBER_REGIST"){
      //   if (item.notiLink.indexOf("/board") == -1) {
      //     if(item.notiKbn == "과제"){
      //       return (item.sendUserName + "님이 " + this.$i18nUtil.trans("entity.project","과제")  + " " + item.notiMessage);
      //     }else{
      //       return (item.sendUserName + "님이 " + item.notiKbn + " " + item.notiMessage);
      //     }
      //   } else {
      //     return item.sendUserName + "님이 보드 " + item.notiMessage;
      //   }
      // }
      // else if(item.notiType == "TYPE_MEMBER_REGIST_OTHER"){ return (item.sendUserName + "님이 " + this.$i18nUtil.trans("entity.project","과제")  + " " + item.notiMessage); }
      // else if(item.notiType == "TYPE_PBOARD_REGIST" ||
      //         item.notiType == "TYPE_FILE_REGIST" ||
      //         item.notiType == "TYPE_OUTPUTS_REGIST"){ 
      //   return item.sendUserName + "님이 " + item.notiMessage;
      // } 
      // // 의견
      // else if(item.notiType == "TYPE_OPINION_REGIST" || 
      //         item.notiType == "TYPE_BLOCK_OPINION_REGIST" || 
      //         item.notiType == "TYPE_PROJECT_OPINION_REGIST" || 
      //         item.notiType == "TYPE_FILE_OPINION_REGIST"){
      //   if (item.notiLink.indexOf("/board") == -1) {
      //     if(item.notiKbn == "과제"){
      //       return (item.sendUserName + "님이 " + this.$i18nUtil.trans("entity.project","과제")  + " " + item.notiMessage);
      //     }else{
      //       return (item.sendUserName + "님이 " + item.notiKbn + " " + item.notiMessage);
      //     }
      //   } else {
      //     return item.sendUserName + "님이 보드 " + item.notiMessage;
      //   }
      // }
      // else if(item.notiType == "TYPE_OPINION_REPLY" || 
      //         item.notiType == "TYPE_PROJECT_OPINION_REPLY" || 
      //         item.notiType == "TYPE_FILE_OPINION_REPLY" || 
      //         item.notiType == "TYPE_BLOCK_OPINION_REPLY"){
      //   return item.sendUserName + "님이 " + item.notiMessage;
      // }
      // // 의사결정
      // else if(item.notiType == "TYPE_DECISION_REQ" || 
      //         item.notiType == "TYPE_DECISION_REJECT" || 
      //         item.notiType == "TYPE_DECISION_APPR"){
      //   return item.notiMessage + "<br>"+ item.sendUserName;
      // }
      // // 할일
      // else if(item.notiType == "TYPE_TODO_REQ" || 
      //         item.notiType == "TYPE_TODO_COMPLETE" || 
      //         item.notiType == "TYPE_TODO_DELETE"){
      //   if(tenantId == "418502"){
      //     return item.notiMessage.replace("할 일이","Task가") + "<br>"+ item.sendUserName;
      //   }else{
      //     return item.notiMessage + "<br>"+ item.sendUserName;
      //   }
      // }
      // // 과제멤버 가입신청 알림.
      // else if(item.notiType == "MAIL_PROJECT_MEMBER_APPLY"){
      //   return item.sendUserName + "님이 " + item.notiMessage.replace("과제",this.$i18nUtil.trans("entity.project","과제"));
      // }
      // else{
      //   // return "정의되지 않은 알림 <br>"+ item.notiMessage +"//"+item.notiType;
      //   return item.sendUserName + "님이 " + item.notiMessage;
      // }
    }
  }
};
</script>

<style scoped>
.history .nodata {
  width: 96%;
}

.calendar_box input{
  color:red;
  background-color: yellow;
}
</style>



// WEBPACK FOOTER //
// src/components/cowork/general/main/modal/Noti.vue